import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  subject: Subject<any> = new Subject<any>();
  subjectProduct: Subject<any> = new Subject<any>();
  subjectCompare: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  subjectCompleteCompare: Subject<any> = new Subject<any>();
  subjectSearch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  storeAllCategories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  storeAllCategoriesHandleSystem: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  storeFlatCategories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  storeFilterByKey: BehaviorSubject<any> = new BehaviorSubject<any>({});
  storeTreeCategories: BehaviorSubject<any> = new BehaviorSubject<any>({});
  preUrl: BehaviorSubject<string> = new BehaviorSubject<any>('');
  storeFilteredCategories: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  updateMyCatalog: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  storeFournissers: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isFlagBack: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private _httpClient: HttpClient) { }

  sendClickEvent(data: any) {
    return this.subject.next(data);
  }
  getClickEvent() {
    return this.subject.asObservable();
  }
  sendClickEventSearch(data: any) {
    return this.subjectSearch.next(data);
  }
  getClickEventSearch() {
    return this.subjectSearch.asObservable();
  }
  sendClickProduct(data: any) {
    return this.subjectProduct.next(data);
  }
  getClickProduct() {
    return this.subjectProduct.asObservable();
  }
  sendClickCompare(data: any) {
    return this.subjectCompare.next(data);
  }
  getClickCompare() {
    return this.subjectCompare.asObservable();
  }
  sendClickCompareComplete() {
    return this.subjectCompleteCompare.next(event);
  }
  getClickCompareComplete() {
    return this.subjectCompleteCompare.asObservable();
  }
  sendClickDeleteCompareComplete(data: any) {
    return this.subjectCompleteCompare.next(data);
  }
  listContact(ids: any[]): Observable<any> {
    return this._httpClient.post('/dynamic-documents/dynamic_natural_person/ids', ids).pipe(map((res: any) => res));
  }
  getDataTariff(ids: any[]): Observable<any> {
    return this._httpClient.post('/view/filtrerById/dynamic_tariff', ids).pipe(map((res: any) => res));
  }
  getUser(id: string | null): Observable<any> {
    return this._httpClient.get<any>(`/dynamic-documents/dynamic_natural_person/${id}`).pipe(map((res: any) => res));
  }
  sendEmailDelAcc(payload: any): Observable<any> {
    return this._httpClient.post('/email/sendMail', payload).pipe(
      map((res: any) => res)
    );
  }
  getInfoAccount(id: any[]): Observable<any> {
    return this._httpClient.post('/view/filtrerById/dynamic_legal_entity', id).pipe(map((res: any) => res));
  }
  getListComparer(id: any[]): Observable<any> {
    return this._httpClient.post('/view/filtrerById/dynamic_product', id).pipe(map((res: any) => res));
  }
  getInfoMember(id: string | null): Observable<any> {
    return this._httpClient.get<any>(`/dynamic-documents/dynamic_legal_entity/${id}`).pipe(map((res: any) => res));
  }
  listCustomer(ids: any[]): Observable<any> {
    return this._httpClient.post('/dynamic-documents/dynamic_legal_entity/ids', ids).pipe(map((res: any) => res));
  }
  getCivility(): Observable<any> {
    return this._httpClient.get<any>('parametre/nomtable/CIVILITY').pipe(map((res: any) => res));
  }
  getRole(): Observable<any> {
    return this._httpClient.get<any>('parametre/nomtable/ROLE').pipe(map((res: any) => res));
  }
  getStatusActif(): Observable<any> {
    return this._httpClient.get<any>('/parametre/nomtable/ACTIF_INACTIF').pipe(map((res: any) => res));
  }
  getStatus(): Observable<any> {
    return this._httpClient.get<any>('/parametre/nomtable/STATUS').pipe(map((res: any) => res));
  }  
  getStatutWorkflow(): Observable<any> {
    return this._httpClient.get<any>('/parametre/nomtable/STATUT_WORKFLOW').pipe(map((res: any) => res));
  }

  getParametreByTableAndValue(tableName: string, value: string): Observable<any> {
    return this._httpClient.get<any>(`/parametre/nomtable/${tableName}/${value}`).pipe(
      map((res: any) => res)
    );
  }
  
  getTypeOfLegalEntity(): Observable<any> {
    return this._httpClient.get<any>('/parametre/nomtable/TYPE_LEGAL_ENTITY').pipe(map((res: any) => res));
  }
  getTypeOfCustomer(): Observable<any> {
    return this._httpClient.get<any>('/dynamic-document-infos/dynamic_legal_entity/typeOfCustomer').pipe(map((res: any) => res));
  }
  deleteCustomer(id: any): Observable<any> {
    return this._httpClient.delete<any>(`dynamic-documents/dynamic_legal_entity/${id}`).pipe(map((res: any) => res));
  }
  deleteContactMember(id: any): Observable<any> {
    return this._httpClient.delete<any>(`dynamic-documents/dynamic_natural_person/${id}`).pipe(map((res: any) => res));
  }

  setStoreAllCategories(allCates: any) {
    this.storeAllCategories.next(allCates);
  }

  getAllCategories() {
    return this.storeAllCategories.asObservable();
  }

  setFlatCategoriesByAllLevel(allCates: any) {
    this.storeFlatCategories.next(allCates)
  }

  getFlatCategories() {
    return this.storeFlatCategories.asObservable();
  }

  setTreeCategories(tree: any) {
    this.storeTreeCategories.next(tree)
  }
  async getTramType(isProduct:boolean) {
    let frameTypeValue = isProduct ? "Produits" : "Tarifs";
  
    let tramType = await firstValueFrom(this.getParametreByTableAndValue("FRAME_TYPE", frameTypeValue));
    return tramType;
  }

  getTreeCategories() {
    return this.storeTreeCategories.asObservable();
  }

  setStoreFournissers(fournisseur: any) {
    this.storeFournissers.next(fournisseur);
  }
  getFournissers() {
    return this.storeFournissers.asObservable();
  }

  setFilterByKey(key: string, value: any) {
    const currentValue = this.storeFilterByKey.getValue();
    const patchValue = { ...currentValue, [key]: value };

    this.storeFilterByKey.next(patchValue);
  }

  getFilterByKey(key: string) {
    return this.storeFilterByKey.getValue()[key];
  }

  setPreUrl(url: string) {
    this.preUrl.next(url);
  }

  getPreUrl() {
    return this.preUrl.getValue();
  }

  setStoreFilteredCategories(allCatalog: any) {
    this.storeFilteredCategories.next(allCatalog);
  }
  getStoreFilteredCategories() {
    return this.storeFilteredCategories.asObservable();
  }

  haveUpdateMyCatalog() {
    this.updateMyCatalog.next(true);
  }

  getUpdateMyCatalog() {
    return this.updateMyCatalog.asObservable();
  }

  setIsFlagBack(value: boolean) {
    if (this.isFlagBack?.value !== value) {
      this.isFlagBack.next(value);
    }
  }

  getIsFlagBack() {
    return this.isFlagBack.asObservable();
  }

  setAllCategoriesHandleSystem(allCates: any) {
    this.storeAllCategoriesHandleSystem.next(allCates);
  }

  getAllCategoriesHandleSystem() {
    return this.storeAllCategoriesHandleSystem.asObservable();
  }

  public downloadFile(url: string, fileName: string): void {
    this._httpClient.get(url, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        const urlBlob = URL.createObjectURL(blob);

        const el = document.createElement('a');
        el.href = urlBlob;
        el.download = fileName; // Le nom que vous souhaitez donner au fichier

        el.click();
        URL.revokeObjectURL(urlBlob); // Nettoyage
      },
      error: () => { }
    });
  }
}

